const GA = process.env.REACT_APP_GA;  // GLOBALADMIN
const SA = process.env.REACT_APP_SA;  // SITEADMIN
const RD = process.env.REACT_APP_READER; // SITEREADER
const UR = process.env.REACT_APP_USR; // SITEUSER

export const SEC_03_USERMANAGEMENT_CONFIG = {
  // 🟢 ORDINAL 0: RESOURCE TYPES (The "Pillars" or Categories)
  ResourceTypes: {
    ordinal: 0, 
    title: "Resource Types",
    description: "Top-level discovery metadata for technical anchors.",
    requiredRoles: [GA],
    endpoints: { 
      fetch: "/api/v1/sustina/manage-users/resource-types",
      add: "/api/v1/sustina/manage-users/resource-types/add",
      update: "/api/v1/sustina/manage-users/resource-types/update"
    },
    relationship: {
      // 🎯 childEntity identifies the sibling pillar key to look up in this config
      childEntity: "Resources", 
      label: "Resource Items", 
      enforceHierarchy: true, 
      
      // 🎯 Join-Table endpoints specific to this relationship
      endpoints: {
        // GET /{parentId}
        fetchLinks: "/api/v1/sustina/manage-users/resource-links",
        // POST { parentId, childId }
        addLink: "/api/v1/sustina/manage-users/resource-links/add",
        // POST { linkId }
        removeLink: "/api/v1/sustina/manage-users/resource-links/remove"
      }
    }
  },

  // 🟢 ORDINAL 1: RESOURCES (The Master Pool of actual Items)
  Resources: {
    ordinal: 2, 
    title: "Resources",
    description: "Individual technical assets and system anchors.",
    requiredRoles: [GA, SA, RD, UR],
    endpoints: { 
      fetch: "/api/v1/sustina/manage-users/resources",
      add: "/api/v1/sustina/manage-users/resources/add",
      // Note: We'll add 'delete' and 'update' once their C# endpoints are finalized
    }
  },

  // 🟢 ORDINAL 2: DIVISIONS (Business Boundaries)
  Divisions: {
    ordinal: 1, 
    title: "Divisions",
    description: "Business entities and organizational boundaries.",
    requiredRoles: [GA, SA, RD, UR],
    endpoints: { 
      fetch: "/api/v1/sustina/manage-users/divisions",
      add: "/api/v1/sustina/manage-users/divisions/add",
      update: "/api/v1/sustina/manage-users/divisions/update"
    }
  }
};